/* eslint-disable complexity */
/**
 * 聊天消息头（群组，会话）
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { useCallback, useContext, useMemo, useEffect, useState, useRef } from "react";
import { message as toast, Modal, Radio, Tooltip, Dropdown, Menu } from "antd";
import "./index.less";
import IconFont from "@/components/icon";
import { getSubscription, followSubscription } from "@/api/sub";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { useTranslation } from "react-i18next";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import {
  Employee,
  Group,
  UID,
  ChatMessage,
  ChatMessageType,
  GroupAttribute,
  Session,
  SessionType,
  MessageStatus
} from "@/types/chat";
import config, { ChatConfig, ConfigEnum, getNetCheckUrl } from "@/config/config";
import clientConfig, { ClientConfigEnum } from "@/config/clientConfig";
import { HeadShowType, SessionSettingsType } from "@/types/chat/enum";
import {
  employeeToUid,
  isEqualEmployee,
  isCrossPlatformGroupSession,
  getSessionIndex,
  messageBurnOfSession,
  isCrossPlatformGroup,
  isExternalGroup,
  generateSessionMid,
  isBannedPostGroupSession,
  sleep
} from "@/utils/chat/message";
import {
  GroupExternalTagBySession,
  AIRobotTag,
  SessionTag,
  singleSessionDeptName,
  inUsageTag
} from "@/components/Tags";
import useGroupUserSelector from "@/components/chat/GroupUserSelector";
import { FocusSDK, JoyMeetingStatusEnum, isFocusEnv } from "@/utils";
import dayjs from "dayjs";
import { openUserSelectionModal } from "@/utils/modals";
import bus from "@/utils/bus";
import Context from "@/components/chat/context";
import { ConferenceType, ConferenceApplyRequest } from "@/components/Voip/types";
import { checkCanAddOperate, isGroupOrdinary } from "@/utils/chat/group";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getGroupMemberList, getRelationship, getMessageTagPageList } from "@/api/chat";
import {
  getSelectorSessions,
  isAIChatSession,
  isAINoticeSession,
  isOrgChatSession
} from "@/utils/chat/session";
import { get, isString } from "lodash";
import { SelectorMode } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import ImService from "@/server/ImService";
import debounce from "lodash/debounce";
import GroupNoticeDrawerList from "@/components/Projects/pages/groupNotice";
import { DrawTypeEnum } from "@/components/chat/enum";
import { getGroupInfo } from "@/api/egroup";
import { useHandleSessionTypeClick } from "../../Session/common";
import { SessionSettingService } from "@/server/im/SessionService";
import prompt from "@/baseComponents/ModalComponent/prompt";
import { NetState } from "@/models/netStatus";
import {
  isChatPage,
  openUserCardModal,
  openOrgAcctModal,
  usePrevious,
  userEscapeString
} from "@/utils/chat/index";
import { crossAppSwitch } from "@/utils/tools";
import { NetType } from "@/components/Modals/ChangeNetModal";
import { handleMeetingClickOperation } from "./operation";
import GroupSpaces from "./comps/GroupSpaces";
import { groupCreates } from "@/components/Joyspace/api";
import events from "@/components/Joyspace/context/events";
import { analysisLog } from "@/utils/logAnalytics";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import i18n from "@/i18n";
import { tagsNode } from "@/components/AddressBook/common";
import MemberCustomAreaExtra from "../InviteForward/MemberCustomAreaExtra";
import { syncConfirmNew } from "@/utils/syncConfirm";
import { setTimeout } from "timers";
import { useHistory } from "react-router-dom";
import { getAppApplyStatus, AppTrialStatus } from "@/components/ThirdApp/utils";
import { getApplicationId } from "@/baseComponents/Meeting/utils";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { handleCreateSingleMeeting as handleCreateSingleZoomMeeting } from "@/components/Meeting/utils";
import { AddressNavKey } from "@/types/common";
import { useHandleContextMenuClick } from "@/components/chat/Session/common";

// 导入新的 CreateGroupButton 组件
import CreateGroupButton from "@/components/chat/CreateGroupButton";

import { CustomMenu } from "@jd/focus-desktop-comps";
import { getShareHintMessageBody } from "../../utils/commonMessageModal";
// import CustomMenu from "@/baseComponents/CustomMenu";
interface MessageHeadProps {
  setCallBack: (type: DrawTypeEnum) => void;
  updateMessages: (data: { messages: ChatMessage[] }) => void;
  changeSelectMore: Function;
  launchSingleSession: Function;
  launchNoticeSession: Function;
  initSelectedSession: Function;
  updateAddressNavKey: Function;
  updateCurrentSubDetailInfo: Function;
  resetCurrentAIRobot: Function;
  updateCurrentAIRobot: Function;
  getLLMTagsList: Function;
  updateSessionMessageMid: Function;
}

const snapchatTimeList = [
  { name: "关闭", value: 0 },
  { name: "1分钟", value: 1 },
  { name: "2分钟", value: 2 },
  { name: "5分钟", value: 5 },
  { name: "30分钟", value: 30 },
  { name: "1小时", value: 60 },
  { name: "24小时", value: 60 * 24 }
];

type IMessageHeadProps = Readonly<MessageHeadProps & ChatState>;

const SessionHeader = (props: IMessageHeadProps & NetState) => {
  const {
    selectedSession,
    currentEmployee,
    sessionMembers,
    setCallBack,
    allSessionList,
    messages,
    updateMessages,
    changeSelectMore,
    launchSingleSession,
    launchNoticeSession,
    initSelectedSession,
    newPublicResult,
    newPrivateResult,
    sessionMessages,
    updateAddressNavKey,
    updateCurrentSubDetailInfo,
    resetCurrentAIRobot,
    updateCurrentAIRobot,
    updateSessionMessageMid,
    getLLMTagsList,
    currentAIRobot,
    llmAgentList,
    llmSetting
  } = props;

  const history = useHistory();

  const { t } = useTranslation("chat");
  const [t_meeting] = useTranslation("meeting");
  const {
    groupRosters,
    groupRosterIdentity,
    userData,
    assistantAI,
    aiMergeOptions,
    lastAIMessage
  } = React.useContext(Context);
  const [isfriend, setIsFriend] = useState(false);
  const [voipClick, SetVoipClick] = useState(false);
  const [zoomClick, SetZoomClick] = useState(false);
  const { userId, teamId, app } = selectedSession.info as Employee;
  const [isDimiss, setIsDimiss] = useState(false);
  const [orgAccountData, setOrgAccountData]: any = useState({});
  const [snapchatTime, setSnapchatTime] = useState(0);
  const [snapchatTimeVisible, setSnapchatTimeVisible] = useState(false);
  const preSelectSession = usePrevious(selectedSession || {});
  const mountedRef = useRef(false);
  const isOutAppGroup = isCrossPlatformGroupSession(selectedSession);
  const crossAppStyle = isOutAppGroup
    ? {
        opacity: 0.5,
        cursor: "not-allowed"
      }
    : {};

  useEffect(() => {
    if (FocusSDK.getCurrentNetType() === NetType.PRIVATE_NET) {
      FocusSDK.checkUrlOnline({
        type: "zoomNet",
        isPrivateNet: true
      });
    }
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  // const doCheckAutoOpenAIMerge = useCallback(
  //   async (rosters) => {
  //     const { whitelist = [] } = aiMergeOptions || {};
  //     const uids = Object.values(rosters || {});
  //     const users = uids.filter((r: any) => {
  //       return whitelist.includes(r?.user?.pin);
  //     });
  //     // 检测是否自动打开智能聚合
  //     const auto = checkGroupAIMergeState(selectedSession, 0) && (users?.length || 0) > 0;
  //     if (auto) {
  //       const fn = SessionSettingService.setSessionGroupAIMerge;
  //       if (!fn) {
  //         return null;
  //       }
  //       try {
  //         return await fn.apply(ImService.getInstance(), [selectedSession.sessionId, true]);
  //       } catch (e) {
  //         return null;
  //       }
  //     }
  //   },
  //   [aiMergeOptions, selectedSession]
  // );

  // useEffect(() => {
  //   if (checkAutoMergeRef.current || !selectedSession?.info) {
  //     return;
  //   }
  //   const info = selectedSession.info as GroupAttribute;
  //   console.log(`tj:>>info111>>>`, info);
  //   if (info && typeof info.aggreMsgStatus === "number") {
  //     // 判断智能聚合
  //     doCheckAutoOpenAIMerge((selectedSession?.info as any)?.rosters);
  //     checkAutoMergeRef.current = true;
  //   }
  // }, [doCheckAutoOpenAIMerge, selectedSession?.info]);

  useEffect(() => {
    // eslint-disable-next-line no-debugger
    if (!selectedSession?.sessionId || preSelectSession?.sessionId === selectedSession?.sessionId) {
      return;
    }
    if (mountedRef.current) setIsDimiss(false);
    if (isOrgChatSession(selectedSession)) {
      loadOrgAcctData();
      return;
    }
    if (!selectedSession.isGroup) {
      return;
    }
    // 优先判断info.flag
    const info = selectedSession.info as GroupAttribute;
    if (info?.status === 0 || info?.flag !== 3) {
      setIsDimiss(true);
      return;
    }
    if (!info) {
      getGroupInfo({
        groupIds: [{ groupId: selectedSession.sessionId || selectedSession.gid || "" }]
      })
        .then((res) => {
          if (res?.groups?.[0]?.status === 0 || res?.groups?.[0]?.flag !== 3) {
            if (mountedRef.current) setIsDimiss(true);
          }
        })
        .catch((e) => {
          console.error("getGroupInfo error", e);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession, preSelectSession]);

  useEffect(() => {
    if (selectedSession.isGroup || selectedSession.isNotice) {
      return;
    }
    (async () => {
      const [result, err] = await getRelationship({
        app,
        pin: userId,
        teamId: teamId
      });
      if (err || !result?.relationship) {
        return;
      }
      const {
        relationship: { relation, friendship }
      } = result;
      if (relation === 1 || friendship === 1) {
        if (mountedRef.current) setIsFriend(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [app, selectedSession.isGroup, selectedSession.isNotice, teamId, userId]);

  useEffect(() => {
    function handleGroupDelete(sessionId: string) {
      if (sessionId === selectedSession.sessionId) {
        if (mountedRef.current) setIsDimiss(true);
      }
    }
    bus.on("chat:group_delete", handleGroupDelete);
    return () => {
      bus.off("chat:group_delete", handleGroupDelete);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession.sessionId]);

  const filterSessionMessages = useCallback(() => {
    if (!sessionMessages) {
      return [];
    }
    const messageTyps = [
      ChatMessageType.IMAGE,
      ChatMessageType.FILE,
      ChatMessageType.EGOV_FILE,
      ChatMessageType.TEXT,
      ChatMessageType.VIDEO,
      ChatMessageType.VOICE,
      ChatMessageType.JOYSPACEFILE,
      ChatMessageType.TEMPLATE2,
      ChatMessageType.LOCATION_JD,
      ChatMessageType.JOYSPACEFOLDER
    ];

    return sessionMessages.filter((item) => {
      let flag = true;
      if (!messageTyps.includes(item.type)) {
        flag = false;
        return flag;
      }
      if (item.revoke === 1) {
        flag = false;
        return flag;
      }
      if (item.type === "file") {
        flag =
          item.status === MessageStatus.SUCCESS ||
          item.statusType === MessageStatus.SUCCESS ||
          !!item.url;
        if (!flag) return flag;
      }
      if (
        item.statusType === MessageStatus.FAILED ||
        item.statusType === MessageStatus.SENDING ||
        item.statusType === MessageStatus.EXPIRED
      ) {
        flag = false;
        return flag;
      }
      if ((item as any).role === 1 || item.plusList?.length) {
        flag = false;
        return flag;
      }
      if (item.fuuid) {
        flag = false;
        return flag;
      }
      return flag;
    });
  }, [sessionMessages]);

  const loadOrgAcctData = async () => {
    const [_r, err]: any = await getSubscription({ subId: selectedSession?.uid?.pin || "" });
    if (err) {
      toast.error(err);
      return;
    }
    setOrgAccountData(_r);
  };

  const searchMessages = useCallback(async () => {
    const filterMessages = filterSessionMessages().slice(-20) || [];
    const needSearch = filterMessages.length < 20 && filterMessages.length > 0;
    const imService = ImService.getInstance();
    let messages: any[] = [];
    if (needSearch) {
      messages = await imService.search({
        sessionId: selectedSession.sessionId,
        searchKey: "",
        desc: true,
        includeBurnAfterRead: true,
        excludeInviteForward: true,
        excludeExpiredMsg: true,
        excludeFailedMsg: true,
        excludeAggregationMsg: true,
        excludeAggregationChildMsg: true,
        excludeGroupNotice: true,
        queryType: 2,
        startMid: filterMessages[0]?.mid
          ? isFocusEnv()
            ? filterMessages[0]?.mid
            : filterMessages[0]?.mid - 1
          : -1,
        limit: 20 - filterMessages.length,
        findTimestamp: filterMessages[0]?.timestamp
      });
      console.log("messages=>", JSON.parse(JSON.stringify(messages)));
    }
    messages = [...messages, ...filterMessages];
    const list: ChatMessage[] = messages.sort(
      (a: any, b: any) => a.timestamp - b.timestamp
    ) as ChatMessage[];
    console.log("list=>", list);
    return list;
  }, [selectedSession.sessionId, filterSessionMessages]);

  const forwardMessages = () => {
    // 合并转发
    const fixedUsers = getSelectorSessions(allSessionList, currentEmployee);
    openUserSelectionModal(
      {
        title: t("select-session-contacts"),
        fixedUsers: fixedUsers,
        frozenIds: [],
        currentUser: employeeToUid(currentEmployee),
        mode: SelectorMode.forward
      },
      (data, close) => {
        doExitAndMergeForward(data);
        close();
      },
      userData
    );

    // 清除信息
    updateMessages({ messages: [] });
    changeSelectMore({ selectMore: false, type: null });
  };
  const exitAndMergeForward = async (data: any) => {
    const list = get(data, "data.result", []);
    if (!list || list.length <= 0) {
      return;
    }
    const imService = ImService.getInstance();
    const sessionId = selectedSession.sessionId;
    const optionResult: { gids: string[]; uids: UID[] } = { gids: [], uids: [] };
    const options = list.reduce((result: { gids: string[]; uids: UID[] }, item: any) => {
      if (item.isGroup) {
        result.gids.push(item.id);
      } else {
        result.uids.push({
          pin: item?.pin,
          app: item?.app,
          teamId: item?.teamId
        });
      }
      return result;
    }, optionResult);
    let mids: number[] = [];
    let joyspacePageIds: string[] = [];
    messages.forEach((message) => {
      if (message.type === ChatMessageType.JOYSPACEFILE) {
        joyspacePageIds.push();
      }
      mids.push(message.mid);
    });
    const result = await imService.mergeForwardMessage(sessionId, mids, options);
    if (isString(result) && result === SessionSettingsType.BANNED_POST) {
      return toast.warn(t("banned_post_tip"));
    }
    if (result) {
      toast.success(t("forwarding-successful"));
      updateMessages({ messages: [] });
      changeSelectMore({ selectMore: false });
    } else {
      toast.error(t("forwarding-failed"));
    }
  };

  const doExitAndMergeForward = debounce(async (data: any) => {
    return exitAndMergeForward(data);
  }, 500);

  const isBanned = useMemo(() => {
    return isGroupOrdinary(groupRosterIdentity) && isBannedPostGroupSession(selectedSession);
  }, [groupRosterIdentity, selectedSession]);

  const openUserSelector = useGroupUserSelector({
    selectedSession,
    currentEmployee,
    sessionMembers,
    groupRosters,
    userData,
    forwardMessages,
    customAreaExtra: !isBanned && (
      <MemberCustomAreaExtra
        selectedSession={selectedSession}
        messages={[]}
        searchMessages={searchMessages}
      />
    )
  });

  // 是否可邀请入群
  // 点击头像触发右侧设置展开栏
  const setting = useCallback(
    (type: DrawTypeEnum) => {
      if (selectedSession.isGroup && (selectedSession.info as any).flag !== 3) return;
      setCallBack(type);
    },
    [setCallBack, selectedSession]
  );

  const doMemberClick = useCallback(
    (e) => {
      e?.stopPropagation();
      setting(DrawTypeEnum.setup);
    },
    [setting]
  );

  const getSessionGroupCountPart = useCallback(() => {
    if (!selectedSession.isGroup) {
      return null;
    }
    const group = (selectedSession.info as Group) || {};
    if (group.flag !== 3 || group.status === 0) return null;
    return (
      <div className="group-member-count-part">
        <Tooltip placement="bottom" title={t("group-size")}>
          <span
            className="member"
            onClick={doMemberClick}
            clstag="pageclick|keycount|Xtbg_Msg|SessionMemberNum"
          >
            <IconFont className="member_icon" type="iconqunchengyuan" />
            <span className="member_count">
              {group.rosterSize || (group.rosters && Object.keys(group.rosters).length)}
            </span>
          </span>
        </Tooltip>
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession.isGroup, selectedSession.info, doMemberClick]);

  const canAddOperate = useMemo(() => {
    return checkCanAddOperate({
      selectedSession,
      currentEmployee,
      groupRosterIdentity
    });
  }, [currentEmployee, groupRosterIdentity, selectedSession]);

  // 使用新的 CreateGroupButton 组件替换原有的 getCreateGroupPart 函数
  const getCreateGroupPart2 = useCallback(() => {
    return (
      <CreateGroupButton
        customAreaExtra={
          !isBanned && (
            <MemberCustomAreaExtra
              selectedSession={selectedSession}
              messages={[]}
              searchMessages={searchMessages}
            />
          )
        }
        // 可以添加自定义样式
        className="add_user"
        // 可以添加自定义 clstag
        clstag={
          selectedSession.isSingle
            ? "pageclick|keycount|Xtbg_Msg|AddMemberIcon_Single"
            : "pageclick|keycount|Xtbg_Msg|AddMemberIcon_Group"
        }
      />
    );
  }, [
    selectedSession,
    currentEmployee,
    groupRosterIdentity,
    groupRosters,
    sessionMembers,
    userData,
    forwardMessages,
    isBanned
  ]);

  const getCreateGroupPart = useCallback(() => {
    if (!canAddOperate) {
      return null;
    }
    const clstag = selectedSession.isSingle
      ? "pageclick|keycount|Xtbg_Msg|AddMemberIcon_Single"
      : "pageclick|keycount|Xtbg_Msg|AddMemberIcon_Group";

    const title = selectedSession.isGroup ? t("add_member") : t("create_group");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div className="add_user no-draggable" onClick={openUserSelector} clstag={clstag}>
          <IconFont type="iconchuangjianqunzu" />
        </div>
      </Tooltip>
    );
  }, [canAddOperate, selectedSession.isSingle, selectedSession.isGroup, t, openUserSelector]);

  const getSetupPart = useCallback(() => {
    if (selectedSession.isSingle) {
      return null;
    }
    if (selectedSession.isGroup) {
      bus.emit("chat:getGroupMembers", selectedSession);
    }
    const clstag = "pageclick|keycount|Xtbg_Msg|SettingIcon";
    const title = t("set_up");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          clstag={clstag}
          className="set_up no-draggable"
          onClick={() => {
            setCallBack(DrawTypeEnum.setup);
          }}
        >
          <IconFont type="iconliaotianshezhi" />
        </div>
      </Tooltip>
    );
  }, [t, setCallBack, selectedSession]);

  // 原始处理器
  const originalHandler = useHandleContextMenuClick({
    sessionId: selectedSession.sessionId,
    selectedSessionId: selectedSession.sessionId,
    t,
    clearSessionMessage: () => {},
    history,
    msg: selectedSession?.lastMsg as ChatMessage,
    session: selectedSession
  });

  const handleContextMenuClick = (e: any) => {
    console.log("handleContextMenuClick", e);
    if (e.key === "setting") {
      setCallBack(DrawTypeEnum.setup);
      return;
    }
    // 调用原始处理器
    return originalHandler(e);
  };

  const handleVoipDropdownContextMenuClick = (e: any) => {
    console.log("handleVoipDropdownContextMenuClick", e);
    if (e.key === "voip") {
      handleMeeting();
    } else {
      handleMeetingClick();
    }
  };

  // 点击语视通话图标展示内容
  const renderVoipDropdownContextMenu = () => {
    const menuItems = [
      {
        key: "voip",
        label: t("voip.audio meeting"),
        icon: <IconFont style={{ scale: "1.4" }} type="iconyuyintonghua" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreDelete"
      },
      {
        key: "meeting",
        label: t("voip.video meeting"),
        icon: <IconFont style={{ scale: "1.4" }} type="iconshipintonghua" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_True"
      }
    ];
    return (
      <CustomMenu
        styleObj={{ minWidth: "124px" }}
        onClick={handleVoipDropdownContextMenuClick}
        items={menuItems}
      />
    );
  };
  // 点击更多图标展示内容
  const renderContextMenu = () => {
    const settings = selectedSession.settings || {};
    const menuItems = [
      {
        key: "setting",
        label: t("set_up"),
        icon: <IconFont className="setting-icon" type="iconliaotianshezhi" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreDelete"
      },
      {
        key: "top",
        label: t("session.menus.top2"),
        icon: <IconFont type="icona-stylezhiding" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_True",
        hidden: (settings.top || 0) > 0
      },
      {
        key: "untop",
        label: t("session.menus.untop2"),
        icon: <IconFont type="icona-stylequxiaozhiding" />,
        onClick: maskHide,
        clstag: "pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_False",
        hidden: (settings.top || 0) === 0
      }
    ];
    return (
      <CustomMenu
        styleObj={{ minWidth: "124px" }}
        onClick={handleContextMenuClick}
        items={menuItems}
      />
      // <Menu onClick={handleContextMenuClick}>
      //   <Menu.Item
      //     key="setting"
      //     onClick={maskHide}
      //     clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreDelete"
      //   >
      //       <IconFont className="setting-icon" type="iconliaotianshezhi" />
      //     {t("set_up")}
      //   </Menu.Item>
      //   {(settings.top || 0) === 0 && (
      //     <Menu.Item
      //       key="top"
      //       onClick={maskHide}
      //       clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_True"
      //     >
      //       <IconFont type="icona-stylezhiding" />
      //       {t("session.menus.top2")}
      //     </Menu.Item>
      //   )}
      //   {(settings.top || 0) > 0 && (
      //     <Menu.Item
      //       key="untop"
      //       onClick={maskHide}
      //       clstag="pageclick|keycount|Xtbg_Msg_Home|InfoMoreTop_False"
      //     >
      //       <IconFont type="icona-stylequxiaozhiding" />
      //       {t("session.menus.untop2")}
      //     </Menu.Item>
      //   )}
      // </Menu>
    );
  };
  const maskShow = () => {
    const mask = document.getElementById("chat-left-mask");
    if (!mask) return;
    mask.style.display = "block";
  };
  const maskHide = () => {
    const mask = document.getElementById("chat-left-mask");
    if (!mask) return;
    mask.style.display = "none";
  };
  const visibleChange = (visible: boolean) => {
    if (visible) {
      maskShow();
      analysisLog("Xtbg_Msg_Home", "InfoMore");
    } else {
      maskHide();
    }
  };

  const getVoipDropdownButton = () => {
    const clstag = "pageclick|keycount|Xtbg_Msg|VoipDropdownButton";
    return (
      <Dropdown
        overlayClassName="sessionHeaderContextMenu"
        overlay={renderVoipDropdownContextMenu}
        trigger={["click"]}
        onVisibleChange={visibleChange}
      >
        <div clstag={clstag} className="voip-dropdown no-draggable">
          <IconFont type="iconshipinyuyin" />
        </div>
      </Dropdown>
    );
  };
  const getMorePart = useCallback(() => {
    if (selectedSession.isGroup) {
      return null;
    }
    const clstag = "pageclick|keycount|Xtbg_Msg|MoreIcon";
    const title = "更多";
    return (
      <Dropdown
        overlayClassName="sessionHeaderContextMenu"
        overlay={renderContextMenu}
        trigger={["click"]}
        onVisibleChange={visibleChange}
      >
        <div clstag={clstag} className="set_up no-draggable">
          <IconFont type="iconqunliaogengduo" />
        </div>
      </Dropdown>
    );
  }, [t, setCallBack, selectedSession]);

  const getSearchPart = useCallback(() => {
    let clstag = "pageclick|keycount|Xtbg_Msg|SearchIcon";
    const title = t("search_session_record");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          clstag={clstag}
          className="search_record no-draggable"
          onMouseDown={() => {
            setCallBack(DrawTypeEnum.search);
          }}
        >
          <IconFont type="iconchazhaohuihuaneirong" />
        </div>
      </Tooltip>
    );
  }, [t, setCallBack]);

  function handleMeetingClick(type?: string) {
    handleMeetingClickOperation({
      selectedSession,
      currentEmployee,
      newPublicResult,
      globalContext: {
        groupRosters,
        userData
      },
      type
    });
  }

  function getCreateMeetingPart() {
    if (!isFocusEnv()) {
      return null;
    }

    if (selectedSession.isSingle) {
      if (!isfriend) {
        return null;
      }
      // // 解析单聊跨平台逻辑 跨平台二期：视频会议支持跨平台
      // const { userId, teamId, app, name, avatar } = selectedSession.info as Employee;
      // if (app !== currentEmployee.app || teamId !== currentEmployee.teamId) {
      //   return null;
      // }
    }
    if (selectedSession.isNotice || selectedSession.isSecret) {
      return null;
    }

    let clstag = "pageclick|keycount|Xtbg_Msg|MeetingIcon_Group";
    if (selectedSession.isSingle) {
      const info = selectedSession.info as Employee;
      if (isEqualEmployee(info, currentEmployee)) {
        // 自已跟自已聊天不能创建群聊
        return null;
      }
      clstag = "pageclick|keycount|Xtbg_Msg|MeetingIcon_Single";
    }

    const title = selectedSession.isGroup
      ? t("joyMeeting.create meeting")
      : t("joyMeeting.create call");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="create_meeting no-draggable"
          onClick={() => handleMeetingClick()}
          clstag={clstag}
        >
          <IconFont type="iconshipinyuyin" />
        </div>
      </Tooltip>
    );
  }
  const handleCreateZoomMeeting = useCallback(async () => {
    const appApplyStatus = await getAppApplyStatus(getApplicationId(AVSDK.ZOOM), true);
    if (appApplyStatus !== AppTrialStatus.NORMAL) {
      toast.warn("请您从工作台进入视频会议应用申请试用权限");
      return;
    }
    if (FocusSDK.getCurrentNetType() === NetType.PRIVATE_NET) {
      if (!newPublicResult) {
        toast.warn(i18n.t("common:joinMeeting.private net"));
        return;
      }
    }
    if (zoomClick) {
      return;
    }
    SetZoomClick(true);
    setTimeout(() => {
      SetZoomClick(false);
    }, 2000);
    const res = await syncConfirmNew("是否发起语音通话？", "语音通话");
    if (!res) {
      return;
    }
    const { userId, teamId, app, name, avatar } = selectedSession.info as Employee;

    handleCreateSingleZoomMeeting({
      from: {
        pin: currentEmployee.userId,
        name: currentEmployee.name,
        teamId: currentEmployee.teamId,
        app: currentEmployee.app,
        avatar: currentEmployee.avatar
      },
      to: {
        name,
        teamId,
        pin: userId,
        app,
        avatar
      }
    }).catch((e) => {
      toast.error(e?.message || e || "创建会议失败");
    });
  }, [
    currentEmployee.app,
    currentEmployee.avatar,
    currentEmployee.name,
    currentEmployee.teamId,
    currentEmployee.userId,
    selectedSession.info,
    zoomClick,
    newPublicResult
  ]);

  const handleMeeting = () => {
    if (config[ConfigEnum.CHAT_SESSION_CREATE_JD_VIDEO_ENABLE]) {
      console.log("voice1");
      handleMeetingClick("voice");
    } else {
      console.log("voice2");
      handleCreateZoomMeeting();
    }
  };

  function getCreateVoipPart() {
    if (!isFocusEnv()) {
      return null;
    }
    if (selectedSession.isNotice || selectedSession.isSecret) {
      return null;
    }
    if (!selectedSession.isSingle) {
      return null;
    }
    // 写群聊的时候把是否是好友放到单聊if里
    if (!isfriend) {
      return;
    }

    // 解析单聊跨平台逻辑
    const sessionSplit = selectedSession.sessionId.split(":");
    if (sessionSplit[1] !== sessionSplit[4]) {
      return null;
    }

    let clstag = "pageclick|keycount|Xtbg_Msg|VoipIcon_Group";
    if (selectedSession.isSingle) {
      const info = selectedSession.info as Employee;
      if (isEqualEmployee(info, currentEmployee)) {
        // 自已跟自已聊天不能创建群聊
        return null;
      }
      clstag = "pageclick|keycount|Xtbg_Msg|VoipIcon_Single";
    } else {
      return null;
    }
    const title = t("voip.audio meeting");

    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="create_meeting no-draggable"
          onClick={handleMeeting}
          clstag={clstag}
          style={crossAppStyle}
        >
          <IconFont type="iconshipinyuyin" />
        </div>
      </Tooltip>
    );
  }

  // 组(群聊)增加公告 --hujun
  const globalcontext = useContext<GlobalContextConfig>(GlobalContext);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const projectType = `project${
    ["mebj", "jgswy", "mebjJZB"].includes(appRuntimeEnv.runtimeConfig.key)
      ? "_" + appRuntimeEnv.runtimeConfig.key
      : ""
  }`;
  const t1 = useTranslation(projectType).t;
  function getCreateGroupNotice() {
    // 不是群组
    if (!selectedSession.isGroup) {
      return null;
    }
    const clstag = "pageclick|keycount|Xtbg_Msg|GroupNoticeIcon";
    const title = t("groupNotice");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="create_meeting no-draggable"
          onClick={() => {
            !isOutAppGroup &&
              GroupNoticeDrawerList({
                prentVisible: true,
                projectId: selectedSession.id || selectedSession.sessionId,
                globalcontext,
                t: t1,
                level: groupRosterIdentity,
                session: selectedSession
              });
          }}
          clstag={clstag}
          style={crossAppStyle}
        >
          <IconFont type="iconic_pc_im_notice2" />
        </div>
      </Tooltip>
    );
  }

  // 组标记
  function getGroupTag() {
    if (!selectedSession.isGroup || !crossAppSwitch("message")) {
      return null;
    }
    const title = t("groupTag");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="open_group_tag no-draggable"
          onClick={(e) => {
            if (!isOutAppGroup) {
              bus.emit("chat:tagList", {
                visible: true
              });
            }
          }}
          style={crossAppStyle}
        >
          <IconFont type="iconic_app_mark" />
        </div>
      </Tooltip>
    );
  }
  // const getAllGroupMembers = useCallback(() => {
  //     if (!(selectedSession as any)?.info.gid) {
  //         return;
  //     }
  //     getGroupMemberList((selectedSession as any)?.info.gid, 'group')
  //         .then(({ data }) => {
  //             console.log('groupRosters', data);
  //             // setGroupRosters(data);
  //         })
  //         .catch((e) => {
  //             console.log(`getGroupMemberList--err`, e);
  //         });
  // }, [selectedSession]);

  // 创建组空间
  const groupCreate = useCallback(async () => {
    const owner = (selectedSession as any)?.info || {};
    const { gid } = owner;
    const gname = owner.name;
    const description = owner.intro;

    const onLine = await netServer.checkNet();
    if (!onLine) {
      toast.error(i18n.t("Network Error"));
      return;
    }
    if (isOutAppGroup) {
      return;
    }
    let groupList = groupRosters;
    try {
      if (Array.isArray(groupList) && !groupList.length) {
        const { data } = await getGroupMemberList(gid, "group");
        groupList = data || [];
      }
      console.log("群组信息", groupList);
      if (!groupList.length) {
        toast.error("该组已解散");
        // return;
      }

      let admins: any = [];
      for (let item of groupList) {
        if (item.identity === "administrator" || item.identity === "sub_administrator") {
          admins.push((item as any).info.userId);
        }
      }
      let result = await groupCreates({
        admins,
        folderId: gid,
        name: gname,
        description,
        parent: "groupRoot"
      });
      if (!result || result.errMsg) {
        toast.error("create_group_team_space_error");
      }
      analysisLog("xtbg_joyspace_1000001", "groupspace-open", gid, gname);
      events.emit("joyspace.groupSpace", {
        visible: true,
        gname: gname,
        gid: gid
      });
    } catch (e) {
      console.error(e, "=asdadadasdadasdad");
      e && toast.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession, groupRosters, t]);

  // 组(群聊)增加组空间
  function getGroupSpace() {
    // 不是群组
    if (!selectedSession.isGroup || !crossAppSwitch("groupSpace") || isOutAppGroup) {
      return null;
    }
    const { gid, name } = selectedSession.info as any;
    return (
      <GroupSpaces
        t={t}
        gid={gid as any}
        openGroupDrawer={async () => {
          groupCreate();
        }}
        crossAppStyle={crossAppStyle}
      />
    );
  }

  const openConfirmModal = () => {
    prompt({
      title: selectedSession.isSecret
        ? t("change-session.normal-chat-title")
        : t("change-session.secret-chat-title"),
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      onOk: async () => {
        handleChangeSession();
      },
      content: selectedSession.isSecret
        ? t("change-session.normal-chat-content")
        : t("change-session.secret-chat-content"),
      okText: t("determine"),
      cancelText: t("cancelText")
    });
  };

  // 切换AI管家
  const openAIAssistant = () => {
    FocusSDK.launchAssistantSession({
      teamId: userData.selectedTeamId,
      token: userData.accessToken,
      question: "",
      ...assistantAI
    });
  };

  const getChangeSessionPart = () => {
    const title = selectedSession.isSecret ? t("change_normal_session") : "切换至阅后即焚会话";
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="change_session no-draggable"
          onClick={() => {
            openConfirmModal();
          }}
          clstag="pageclick|keycount|Xtbg_Msg|ChangeSessionIcon"
        >
          <IconFont type="iconic_pc_im_returnchat" />
        </div>
      </Tooltip>
    );
  };

  // 切换AI智能客服
  const getAIAssistantPart = () => {
    if (selectedSession.isNotice) {
      return null;
    }
    const title = "管家助理";
    if (assistantAI?.isAssistantAI === 1) {
      return (
        <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
          <div className="open_group_tag no-draggable" onClick={openAIAssistant}>
            <IconFont type="iconlianxiang1" />
          </div>
        </Tooltip>
      );
    } else {
      return null;
    }
  };

  function findSnapChatSession() {
    const index = getSessionIndex(allSessionList, {
      sessionId: `${selectedSession.sessionId}:secret`
    });
    return index > -1;
  }

  const handleChangeSession = useHandleSessionTypeClick({
    selectedSession,
    launchSingleSession,
    initSelectedSession,
    updateMessages,
    changeSelectMore,
    history
  });

  const getSnapchatTimePart = () => {
    const title = t("snapchat_time");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="set_snapchat_time no-draggable"
          onClick={() => {
            setSnapchatTimeVisible(true);
            const messageBurn = messageBurnOfSession(selectedSession);
            setSnapchatTime(messageBurn ? messageBurn / 60 : 0);
          }}
          clstag="pageclick|keycount|Xtbg_Msg|SetSnapchatTimeIcon"
        >
          <IconFont
            className={`${messageBurnOfSession(selectedSession) ? "iconic_ap_fire_nomal" : ""}`}
            type="iconic_pc_im_fire1"
          />
        </div>
      </Tooltip>
    );
  };

  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl(),
    checkType: UseCheckType.API
  });

  async function sendSnapchatSysMessage() {
    // 设置会话阅后即焚时间、发送系统消息、都成功之后关闭弹框
    const imservice = ImService.getInstance();
    const sessionId = selectedSession.sessionId;
    const onLine = await netServer.checkNet();
    if (!onLine) {
      toast.error(i18n.t("Network Error"));
    }
    const result = await SessionSettingService.setSessionMessageBurn.call(
      imservice,
      sessionId,
      snapchatTime * 60
    );
    if (result) {
      setSnapchatTimeVisible(false);
      imservice?.sendSystemMessage(sessionId, {
        content: snapchatTime
          ? snapchatTime >= 60
            ? `的消息阅后即焚设置为${snapchatTime / 60}小时`
            : `的消息阅后即焚设置为${snapchatTime}分钟`
          : "已关闭“阅后即焚”",
        type: ChatMessageType.SYS,
        flag: 3
      });
    } else {
      console.log("设置阅后即焚时间失败");
    }
  }

  const updateShareCard = useCallback(
    async (settings: any) => {
      if (!isAIChatSession(selectedSession)) {
        return;
      }
      // 欢迎语
      const msg = await getShareHintMessageBody(currentEmployee, settings);
      console.log("tj:>>>updateShareCard>>", settings, msg, selectedSession?.sessionId);
      updateSessionMessageMid({
        sessionId: selectedSession?.sessionId,
        sendResult: {
          body: { ...msg }
        },
        force: true,
        saveLocal: false,
        picksKey: ["mid", "status", "flag"]
      });
    },
    [currentEmployee, selectedSession?.sessionId, updateSessionMessageMid]
  );

  const handleChangeAgent = useCallback(
    async (item: any) => {
      FocusSDK.sendToMain("ai:global:aiAgentChange", {
        ...item
      });
      // 停止
      resetCurrentAIRobot({
        agentInfo: item,
        messageId: lastAIMessage?.id || ""
      });
      getLLMTagsList({
        agentId: item?.agentId,
        force: true
      });
    },
    [getLLMTagsList, resetCurrentAIRobot, lastAIMessage?.id]
  );

  useEffect(() => {
    updateShareCard(llmSetting);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [llmSetting]);

  const commAIHeader = useMemo(() => {
    return (
      <div className="aichat-header-wrap">
        <img src={currentAIRobot?.agentIcon} />
        <Dropdown
          trigger={["click"]}
          overlay={
            <div className="aichat-dropdown">
              {llmAgentList.map((item: any) => {
                return (
                  <div
                    className="item"
                    onClick={() => handleChangeAgent(item)}
                    key={`ai-robot_item_${item.agentId}`}
                  >
                    <img className="ai-icon" src={item.agentIcon} />
                    <div className="ai-info">
                      <div className="ai-title-wrap">
                        <span className="ai-title">{item.agentName}</span>
                        {currentAIRobot?.agentId === item?.agentId ? inUsageTag() : null}
                      </div>
                      <span className="ai-desc">{item?.agentDesc}</span>
                    </div>
                  </div>
                );
              })}
              <div className="footer">更多助理待接入</div>
            </div>
          }
        >
          <div className="text-wrap">
            <span className="text">{currentAIRobot?.agentName}</span>
            <IconFont className="text-icon" type="iconicon_down" />
          </div>
        </Dropdown>
      </div>
    );
  }, [currentAIRobot, llmAgentList, handleChangeAgent]);

  const remark = useMemo(() => {
    const employeeExt = (selectedSession.info as any)?.employeeExt || {};
    const remark = employeeExt?.remark;
    return remark;
  }, [selectedSession]);

  const name = useMemo(() => {
    return `${selectedSession?.name || selectedSession?.info?.name}${
      remark ? `（${remark}）` : ""
    }`;
  }, [selectedSession, remark]);

  const handleHomePageClick = useCallback(() => {
    updateAddressNavKey({ addressNavKey: AddressNavKey.BROADCAST });
    history.push("/address_list");
    updateCurrentSubDetailInfo?.({
      subId: (selectedSession?.info as Employee)?.userId,
      visible: true
    });
  }, [selectedSession]);

  const getHomepagePart = useCallback(() => {
    const title = t("home_page");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="homepage-icon icon-item no-draggable"
          onClick={() => {
            openOrgAcctModal(selectedSession.uid?.pin || "");
          }}
        >
          <IconFont type="iconpc_yundoc_home" />
        </div>
      </Tooltip>
    );
  }, [t, setCallBack, selectedSession]);

  const getOrgContentMgtPart = useCallback(() => {
    const title = t("content_mgt");
    return (
      <Tooltip title={title} overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
        <div
          className="icon-item no-draggable"
          onClick={() => {
            let contentMgtLink = `${FocusSDK.getMeMainEntry()}/orgAccountMgt#/?subId=${
              selectedSession.uid?.pin || ""
            }`;
            window.open(contentMgtLink);
          }}
        >
          <IconFont type="iconiconbtn_manager" />
        </div>
      </Tooltip>
    );
  }, [t, setCallBack, selectedSession]);

  const isAppRobotSession = useMemo(() => {
    return selectedSession.uid?.pin?.startsWith("robot_");
  }, [selectedSession]);

  const getOrgHeader = useCallback(() => {
    return (
      <div className="action-button">
        {getHomepagePart()}
        {/* 仅运营者显示内容管理入口 */}
        {orgAccountData.isOperator === 1 && getOrgContentMgtPart()}
        {getSetupPart()}
      </div>
    );
  }, [getHomepagePart, getSetupPart, orgAccountData]);

  const getAppRobotHeader = useCallback(() => {
    return (
      <div className="action-button">
        {!isAINoticeSession(selectedSession) &&
          selectedSession.sessionId &&
          !selectedSession.isNotice &&
          getSearchPart()}

        {!isDimiss && selectedSession.sessionId && getSetupPart()}
      </div>
    );
  }, [getSearchPart, getSetupPart, isDimiss, selectedSession]);

  const handleChangeAgentType = useCallback(() => {
    updateCurrentAIRobot({
      type: currentAIRobot?.type === "video" ? "chat" : "video"
    });
  }, [currentAIRobot?.type, updateCurrentAIRobot]);

  const getAIChatActionHeader = useCallback(() => {
    // 当前agent切换数字人
    if (currentAIRobot?.dmUrl) {
      return (
        <div className="action-button">
          <Tooltip title="视频通话" overlayStyle={{ whiteSpace: "nowrap" }} placement="bottom">
            <div className="ai-agent-action-btn no-draggable" onClick={handleChangeAgentType}>
              <span
                className={`ai-agent-action-icon ${
                  currentAIRobot?.type === "video" ? "chat-icon" : "video-icon"
                }`}
              />
              <span className="ai-agent-text">
                {currentAIRobot?.type === "video" ? "文字沟通" : "视频沟通"}
              </span>
            </div>
          </Tooltip>
        </div>
      );
    } else {
      return null;
    }
  }, [currentAIRobot?.dmUrl, currentAIRobot?.type, handleChangeAgentType]);

  const getBottomTool = useCallback(() => {
    return (
      <div className="group-session-header-toolbar">
        <div className="group-session-header-toolbar-item active">
          <IconFont type="iconxiaoxi1" />
          消息
        </div>
        {!isDimiss && !isOutAppGroup && (
          <div
            className="group-session-header-toolbar-item"
            onClick={() => {
              !isOutAppGroup &&
                GroupNoticeDrawerList({
                  prentVisible: true,
                  projectId: selectedSession.id || selectedSession.sessionId,
                  globalcontext,
                  t: t1,
                  level: groupRosterIdentity,
                  session: selectedSession
                });
            }}
          >
            <IconFont style={{ color: "#0DBC00" }} type="iconqungonggao" />
            群公告
          </div>
        )}
        {!isDimiss && getGroupSpace()}
        {/* <div className="group-session-header-toolbar-item">
          <IconFont
            style={{ color: "#FFC300" }}
            type="iconqunwenjian"
          />
          群文件</div> */}
      </div>
    );
  }, [selectedSession]);

  const showVoipDropdownButton = () => {
    if (!isFocusEnv()) {
      return false;
    }
    if (selectedSession.isNotice || selectedSession.isSecret) {
      return false;
    }
    if (!selectedSession.isSingle) {
      return false;
    }
    // 写群聊的时候把是否是好友放到单聊if里
    if (!isfriend) {
      return false;
    }

    // 解析单聊跨平台逻辑
    if (selectedSession.isSingle) {
      const sessionSplit = selectedSession.sessionId.split(":");
      if (sessionSplit[1] !== sessionSplit[4]) {
        return false;
      }
      const info = selectedSession.info as Employee;
      if (isEqualEmployee(info, currentEmployee)) {
        // 自已跟自已聊天不能创建群聊
        return false;
      }
    }
    if (!config[ChatConfig.CHAT_SESSION_CREATE_VOIP_ENABLE]) {
      return false;
    }
    if (isDimiss) {
      return false;
    }
    if (!config[ChatConfig.CHAT_SESSION_CREATE_MEETING_ENABLE]) {
      return false;
    }
    return true;
  };

  return (
    <div className="message-head-container grey">
      <div className="message-head-inner no-draggable">
        {!selectedSession.isSecret && !isAIChatSession(selectedSession) && (
          <div
            onClick={() => setting(DrawTypeEnum.setup)}
            clstag="pageclick|keycount|Xtbg_Msg|SessionAvatar"
            style={{ marginLeft: "16px" }}
          >
            <HeadPortrait
              member={selectedSession}
              key={0}
              width="36px"
              height="36px"
              fontSize="13px"
              imgUrl={selectedSession?.info?.avatar}
              name={selectedSession?.info?.name}
              type={selectedSession.sessionType}
              isUnFollow={true}
              showType={HeadShowType.SESSION}
              avatarMask={true}
            />
          </div>
        )}
        {isAIChatSession(selectedSession) ? (
          commAIHeader
        ) : (
          <div className={`name-notice ${selectedSession.isSecret ? "secret-name-notice" : ""}`}>
            <div className="name">
              {selectedSession.isSecret && (
                <div className="secret">
                  <IconFont
                    style={{ color: "#F96137" }}
                    type="iconic_app_im_burnafterreading_facet"
                  />
                </div>
              )}

              <Tooltip
                placement="bottom"
                title={<span dangerouslySetInnerHTML={{ __html: userEscapeString(name) }} />}
              >
                <span
                  className="name-1"
                  onClick={() => {
                    console.log("selectedSession:", selectedSession);
                    if (isOrgChatSession(selectedSession)) {
                      openOrgAcctModal(selectedSession.uid?.pin || "");
                      return;
                    }
                    if (selectedSession.isSingle && !selectedSession.isNotice) {
                      const user: any = selectedSession.uid
                        ? selectedSession.info
                        : selectedSession.uid;
                      openUserCardModal({
                        userId: user.userId || user.pin,
                        teamId: user.teamId,
                        app: user.app
                      } as any);
                    } else {
                      setting(DrawTypeEnum.setup);
                    }
                  }}
                  clstag="pageclick|keycount|Xtbg_Msg|SessionName"
                  dangerouslySetInnerHTML={{
                    __html: userEscapeString(name)
                  }}
                />
              </Tooltip>
              {/* {selectedSession?.info?.name}
                        </span> */}
              {getSessionGroupCountPart()}
              {selectedSession.isSingle && tagsNode(selectedSession?.info?.labelInfoList)}
              <GroupExternalTagBySession session={selectedSession} />
              <SessionTag session={selectedSession} currentEmployee={currentEmployee} needJump />
              {/* <AIRobotTag session={selectedSession} /> */}
              {singleSessionDeptName(selectedSession)}
            </div>
            {selectedSession.isGroup && getBottomTool()}
          </div>
        )}
      </div>
      {isAIChatSession(selectedSession) ? (
        getAIChatActionHeader()
      ) : isOrgChatSession(selectedSession) ? (
        getOrgHeader()
      ) : (
        <>
          {isAppRobotSession ? (
            getAppRobotHeader()
          ) : (
            <div className="action-button">
              {getAIAssistantPart()}
              {/* 暂时隐藏组标记 */}
              {/* {getGroupTag()}  */}
              {/* 单聊密聊或者会话列表创建过密聊 */}
              {/* 聊天窗口视频会议 */}
              {/* {isLLMAI &&
            (isAINoticeSession(selectedSession) || isAIChatSession(selectedSession)) &&
            getChangeAIChatPart()} */}
              {selectedSession.isSingle &&
                (selectedSession.isSecret || findSnapChatSession()) &&
                !isChatPage() &&
                getChangeSessionPart()}
              {!isAINoticeSession(selectedSession) &&
                selectedSession.sessionId &&
                !selectedSession.isNotice &&
                getSearchPart()}
              {selectedSession.isSingle && selectedSession.isSecret && getSnapchatTimePart()}
              {/* {!isDimiss && getCreateGroupNotice()} */}
              {/* {!isDimiss && getGroupSpace()} */}
              {showVoipDropdownButton() && getVoipDropdownButton()}
              {!showVoipDropdownButton() &&
                config[ChatConfig.CHAT_SESSION_CREATE_VOIP_ENABLE] &&
                getCreateVoipPart()}
              {!showVoipDropdownButton() &&
                !isDimiss &&
                config[ChatConfig.CHAT_SESSION_CREATE_MEETING_ENABLE] &&
                getCreateMeetingPart()}
              {!isDimiss && getCreateGroupPart2()}
              {!isDimiss && selectedSession.sessionId && getSetupPart()}
              {selectedSession.sessionId && getMorePart()}
            </div>
          )}
          <Modal
            visible={snapchatTimeVisible}
            title="设置消息阅后即焚时间"
            width={420}
            okText={t("button.ok")}
            cancelText={t("button.cancel")}
            wrapClassName="snapchatTimeModal"
            centered={true}
            destroyOnClose={true}
            maskClosable={false}
            onCancel={() => setSnapchatTimeVisible(false)}
            onOk={() => {
              sendSnapchatSysMessage();
            }}
          >
            <Radio.Group onChange={(e) => setSnapchatTime(e.target.value)} value={snapchatTime}>
              {snapchatTimeList.map((item) => (
                <Radio.Button key={item.value} value={item.value}>
                  {item.name}
                </Radio.Button>
              ))}
            </Radio.Group>
          </Modal>
        </>
      )}
      {/* {prentVisible && <GroupTagList />} */}
    </div>
  );
};

function mapStateToProps({ chat, netStatus }: any) {
  const {
    selectedSession,
    currentEmployee,
    sessionMembers,
    allSessionList,
    messages,
    sessionMessageMap,
    currentAIRobot,
    llmAgentList,
    llmSetting
  } = chat as ChatState;
  const sessionMessages: ChatMessage[] = sessionMessageMap[selectedSession.sessionId] || [];
  const { newPublicResult, newPrivateResult } = netStatus;
  return {
    selectedSession,
    currentEmployee,
    sessionMembers,
    allSessionList,
    messages,
    newPublicResult,
    newPrivateResult,
    sessionMessages,
    currentAIRobot,
    llmAgentList,
    llmSetting
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateMessages(data: { messages: ChatMessage[] }) {
      dispatch({ type: "chat/updateMessages", payload: data });
    },
    changeSelectMore(data: { selectMore: boolean }) {
      dispatch({ type: "chat/changeSelectMore", payload: data });
    },
    launchSingleSession(data: { employee: Employee }) {
      dispatch({ type: "chat/launchSingleSession", payload: data });
    },
    launchNoticeSession(data: { sid: string }) {
      dispatch({ type: "chat/launchNoticeSession", payload: data });
    },
    initSelectedSession(data: { selectedSession: Session }) {
      dispatch({ type: "chat/initSelectedSession", payload: data });
    },
    updateAddressNavKey(data: { addressNavKey: AddressNavKey }) {
      dispatch({ type: "ebook/updateAddressNavKey", payload: data });
    },
    updateCurrentSubDetailInfo(payload: any) {
      dispatch({ type: "sub/updateCurrentSubDetailInfo", payload });
    },
    resetCurrentAIRobot(payload: any) {
      dispatch({ type: "chat/resetCurrentAIRobot", payload });
    },
    updateCurrentAIRobot(payload: any) {
      dispatch({ type: "chat/updateCurrentAIRobot", payload });
    },
    getLLMTagsList(payload: any) {
      dispatch({ type: "chat/getLLMTagsList", payload });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: string }) {
      return dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SessionHeader);
